import React from 'react'
import { Link } from 'react-router-dom';

function Sait() {
    return (
        <div>В разработке
            <div className='block__videos_a_href'>
                <a href="#" className="button">
                    <div className="button__line"></div>
                    <div className="button__line"></div>
                    <Link component={Link} to="/" className="button__text">Шаг назад</Link>
                    <div className="button__drow1"></div>
                    <div className="button__drow2"></div>
                </a>
            </div>
        </div>
    )
}

export default Sait;
